export default {
	TABLE_TITLE: 'Currencies',
	CURRENCY_ADDED: 'Currency added',
	CURRENCY_EDITED: 'Currency edited',
	CURRENCY_DELETED: 'Currency deleted',
	DETAILS_TOOLTIP: 'Go to details',
};
